import React from "react"
import { Container, Row, Col } from "reactstrap";
const Footer = () => {
  const currentYear = new Date().getFullYear(); // Dynamically get the current year
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid ={true}>
          <Row className="justify-content-center">
            <Col sm={6} >
            {/* <p className="mb-0 text-muted text-sm-start text-center">{new Date().getFullYear()} © (C) LINC Education Services Pte. Ltd. 2024</p> */}
            <p className="mb-0 text-muted text-center">
                {currentYear} ©  LINC Education Services Pte. Ltd.,
              </p>
            </Col>
            {/* <Col sm={6}>
              <div className="text-sm-end mt-sm-0 mt-1">
              <p className="mb-0 text-muted text-sm-end text-center">Designed by <a href="https://capdigisoft.com/" target="_blanck">  CAP Digisoft</a></p>
              </div>
            </Col> */}
          </Row>
        </Container>
      </footer>
    </React.Fragment>

  );
}

export default Footer;